export const ProStoreReducerInitialState = {
  id: '',
  active: false,
  profile: {},
  products: [],
  vendors: [],
  productCategories: [],
};
